import zIndex from '@/modules/constants/zIndex';
import { styled } from '@volkswagen-onehub/components-core';

interface StyledFixedTopContainerProps {
  reveal: boolean;
  nudgeDown: boolean;
  topPx: string | number;
  nudgeTopPx: string | number;
}

const getYPosition = ({
  reveal,
  nudgeDown,
  nudgeTopPx,
  topPx,
}: StyledFixedTopContainerProps) => {
  if (reveal) {
    return nudgeDown ? `${nudgeTopPx}px` : '0';
  } else {
    return `calc(-100% - ${topPx}px)`;
  }
};

export const StyledFixedTopContainer = styled.div<StyledFixedTopContainerProps>(
  ({ reveal, nudgeDown, nudgeTopPx, topPx }) => {
    return `
      position: fixed;
      width: 100%;
      top: ${topPx}px;
      left: 0;
      z-index: ${zIndex.NAV};
      transform: translateY(${getYPosition({
        nudgeTopPx,
        nudgeDown,
        topPx,
        reveal,
      })});
      transition: transform 0.3s ease-in ${nudgeDown ? '100ms' : '0s'} ;
    `;
  }
);
